import type { SheetCloseEvent } from '../services/tracking/TrackingPayload.ts';
import type { TeaserType } from './teaser/TeaserType.ts';
import type { TeaserContent } from './teaser/TeaserContent.ts';
import { TeaserTouchPoint } from './teaser/TeaserUtils.ts';

export type Sheet = {
	readonly title?: string,
	readonly url: string,
	readonly lockMobileHeight?: boolean,
	readonly showBackButton?: boolean,
	readonly fullBleedContent?: boolean,
	readonly initialMobileHeight?: string,
	readonly menuContent?: string
	readonly closeCallback?: (event: SheetCloseEvent) => void
};

export const basicSignUpSuccessNewDesignSheet = (adaptiveAlignment: string) => {
	return {
		id: 'basic-signup-success-sheet',
		url: '/up-teaserui/signup/success',
		noContentPadding: true,
		hideHeader: true,
		adaptiveAlignment: adaptiveAlignment,
		hideBackButton: true
	}
};

export const basicSubscriptionErrorNewDesignSheet = () => {
	return {
		url: '/up-teaserui/signup/error',
		headline: 'OTTO UP Mitgliedschaft',
		noContentPadding: true
	};
};

export const termsAndConditionsSheet = () => {
	return {
		id: 'terms-and-conditions-sheet',
		headline: 'OTTO UP Teilnahmebedingungen',
		url: '/up-teaserui/terms-and-conditions',
		fullHeight: true,
		noContentPadding: true
	};
};

export const dataProtectionSheet = () => {
	return {
		id: 'data-protection-sheet',
		headline: 'Datenschutzes',
		url: '/up-teaserui/data-protection',
		fullHeight: true,
		noContentPadding: true
	};
};

export const oldPointsInfoBannerSignUpSheet = (upgradeSheetTitle: string, upgradeSheetURL: string | undefined) => {
	return {
		id: 'old-points-info-banner-signup-sheet',
		headline: upgradeSheetTitle,
		url: upgradeSheetURL,
		noContentPadding: true
	};
};

export const pointsInfoBannerSignUpSheet = (upgradeSheetTitle: string, upgradeSheetURL: string | undefined) => {
	return {
		id: 'points-info-banner-signup-sheet',
		hideHeader: true,
		url: upgradeSheetURL,
		noContentPadding: true
	};
};

export const buildUrl = (teaserContent :TeaserContent, teaserTouchPoint: TeaserTouchPoint | undefined) => {
	let url = teaserContent.sheetUrl;
	if (teaserContent.scarcity) {
		url += `&scarcity=${teaserContent.scarcity}`;
	}
	if (teaserTouchPoint) {
		url += `&teaserTouchPoint=${teaserTouchPoint}`;
	}
	return url;
}

export const toSignUpSheet = (teaserType: TeaserType, teaserContent: TeaserContent, teaserTouchPoint: TeaserTouchPoint | undefined) => {
	return {
		id: `teaser-${teaserType}`,
		headline: teaserContent.sheetTitle,
		url: buildUrl(teaserContent, teaserTouchPoint),
		noContentPadding: true
	};
};

export const toNewProgramStructureSignUpSheet= (teaserType: TeaserType, teaserContent: TeaserContent, teaserTouchPoint: TeaserTouchPoint | undefined) => {
	return {
		id: `teaser-${teaserType}`,
		headline: teaserContent.sheetTitle,
		url: buildUrl(teaserContent, teaserTouchPoint),
		noContentPadding: true,
		hideHeader: true,
		adaptiveAlignment: 'center'
	};
};

export const toNewSignUpSheet = (teaserType: TeaserType, teaserContent: TeaserContent, teaserTouchPoint: TeaserTouchPoint | undefined) => {
	return {
		id: `teaser-${teaserType}`,
		url: buildUrl(teaserContent, teaserTouchPoint),
		noContentPadding: true,
		hideHeader: true
	};
};
